import { env } from '@didi/utils'
import dbridge from '@didi/driver-bridge'
import FusionClass from '@didi/fusion'

const bridge = (() => {
  if (env.isDriver) return dbridge
  else if (env.rainbow) {
    return new FusionClass(['DidiBridgeAdapter', 'TraceModule'])
  }
})()

export default bridge
